'use client'

interface TermlyContentProps {
  html: string
}

export function TermlyContent({ html }: TermlyContentProps) {
  return (
    <div
      className="termly-content"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
